export const PRODUCTS = {
  CREATE_PRODUCTS: "create_products",
  READ_PRODUCTS: "read_products",
  UPDATE_PRODUCTS: "update_products",
  DELETE_PRODUCTS: "delete_products",
};

export const PRICEBOOKS = {
  CREATE_PRICEBOOKS: "create_pricebooks",
  READ_PRICEBOOKS: "read_pricebooks",
  UPDATE_PRICEBOOKS: "update_pricebooks",
  DELETE_PRICEBOOKS: "delete_pricebooks",
};

// Pipeline permissions also covers Assets
export const PIPELINE = {
  CREATE_DEALS: "create_deals",
  READ_DEALS: "read_deals",
  UPDATE_DEALS: "update_deals",
  DELETE_DEALS: "delete_deals",
  MODIFY_ALL_DEALS: "modify_all_deals",
};

export const TEMPLATES = {
  CREATE_TEMPLATES: "create_templates",
  READ_TEMPLATES: "read_templates",
  UPDATE_TEMPLATES: "update_templates",
  DELETE_TEMPLATES: "delete_templates",
};

export const WORKFLOWS = {
  CREATE_WORKFLOWS: "create_workflows",
  READ_WORKFLOWS: "read_workflows",
  UPDATE_WORKFLOWS: "update_workflows",
  DELETE_WORKFLOWS: "delete_workflows",
};

export const SETTINGS = {
  MANAGE_COMPANY_SETTINGS: "manage_company_settings",
};



// WEBPACK FOOTER //
// ./src/constants/permissions.js